export default defineAppConfig({
  ui: {
    colors: {
      primary: "primary",
      secondary: "secondary",
      success: "green",
      info: "blue",
      warning: "amber",
      error: "red",
      neutral: "neutral",
    },
    header: {
      slots: {
        root: "h-auto py-3 px-12 bg-white rounded-b-2xl border-none gap-2 shadow-[1px_2px_8px_0px_#5A698740]",
        container: "p-0!",
      },
    },
    dashboardGroup: {
      base: "bg-secondary-100",
    },
    dashboardSidebar: {
      slots: {
        root: "bg-white min-w-58 px-4 py-6",
        body: "gap-6 p-0",
        footer: "p-0 border-none",
      },
      variants: {
        side: {
          left: {
            root: "border-0 shadow-[1px_1px_8px_0px_#5A698740]",
          },
        },
      },
    },
    dashboardPanel: {
      slots: {
        body: "p-6",
      },
    },
    navigationMenu: {
      slots: {
        link: "gap-2 text-base font-medium leading-sm rounded-lg",
        linkLeadingIcon: "size-6",
        linkTrailingIcon: "size-6",
      },
      variants: {
        orientation: {
          vertical: {
            item: "mt-2",
            link: "p-2",
          },
        },
        active: {
          false: {
            link: "text-neutral-700",
            linkLeadingIcon: "text-neutral-700",
          },
        },
      },
      compoundVariants: [
        {
          color: "primary",
          variant: "pill",
          active: true,
          class: {
            link: "text-primary-700",
            linkLeadingIcon:
              "text-primary-700 group-data-[state=open]:text-primary-700",
          },
        },
        {
          variant: "pill",
          active: true,
          highlight: false,
          class: {
            link: "before:bg-neutral-50",
          },
        },
      ],
    },
    toast: {
      slots: {
        root: "p-2 flex gap-2 shadow-[1px_2px_8px_0px_#5A698740] outline-white",
        icon: "p-1 size-7 rounded-md",
        title: "text-base font-semibold text-text-neutral-lv1 line-clamp-1",
        description:
          "text-sm font-regular leading-sm text-text-neutral-lv2 line-clamp-2",
      },
      variants: {
        color: {
          success: {
            // root: 'outline-success/25 focus-visible:outline-3 focus-visible:ring-success',
            icon: "text-icon-green bg-bg-green",
          },
          info: {
            // root: 'outline-info/25 focus-visible:outline-3 focus-visible:ring-info',
            icon: "text-icon-blue bg-bg-blue",
          },
          warning: {
            // root: 'outline-warning/25 focus-visible:outline-3 focus-visible:ring-warning',
            icon: "text-icon-amber bg-bg-amber",
          },
          error: {
            // root: 'outline-error/25 focus-visible:outline-3 focus-visible:ring-error',
            icon: "text-icon-red bg-bg-red",
          },
        },
        orientation: {
          horizontal: {
            root: "items-start",
            actions: "self-center",
          },
          // vertical: {
          //   root: 'items-start',
          //   actions: 'items-start mt-2.5'
          // }
        },
      },
      defaultVariants: {
        color: "success",
      },
    },
    alert: {
      slots: {
        root: "py-2 px-3 min-h-10 !items-center",
        icon: "size-5 leading-sm",
        title: "text-xs font-bold leading-sm line-clamp-1",
        description: "text-sm font-regular leading-sm",
      },
      compoundVariants: [
        {
          color: "success",
          variant: "subtle",
          class: {
            root: "bg-bg-green text-text-green ring-border-green",
          },
        },
        {
          color: "info",
          variant: "subtle",
          class: {
            root: "bg-bg-blue text-text-blue ring-border-blue",
          },
        },
        {
          color: "error",
          variant: "subtle",
          class: {
            root: "bg-bg-red text-text-red ring-border-red",
          },
        },
        {
          color: "warning",
          variant: "subtle",
          class: {
            root: "bg-bg-amber text-text-amber ring-border-amber",
          },
        },
        {
          color: "neutral",
          variant: "subtle",
          class: {
            root: "bg-bg-surface-lv2 text-text-neutral-lv1 ring-border-neutral-lv1",
          },
        },
      ],
      defaultVariants: {
        color: "neutral",
        variant: "subtle",
        orientation: "horizontal",
      },
    },
    button: {
      slots: {
        base: "cursor-pointer justify-center",
      },
      variants: {
        size: {
          sm: {
            base: "p-2 rounded-md gap-1 text-xs leading-xs font-bold h-[24px]",
            leadingIcon: "size-3",
            leadingAvatarSize: "3xs",
            trailingIcon: "size-3",
          },
          md: {
            base: "px-4 py-2 rounded-md gap-1 text-sm leading-sm font-bold h-[32px]",
            leadingIcon: "size-4",
            leadingAvatarSize: "2xs",
            trailingIcon: "size-4",
          },
          lg: {
            base: "px-4 py-2 rounded-lg gap-2 text-base leading-sm font-bold h-[40px]",
            leadingIcon: "size-4",
            leadingAvatarSize: "2xs",
            trailingIcon: "size-4",
          },
          xl: {
            base: "px-4 py-2 rounded-lg gap-2 text-base leading-sm font-bold h-[48px]",
            leadingIcon: "size-4",
            leadingAvatarSize: "2xs",
            trailingIcon: "size-4",
          },
        },
      },

      compoundVariants: [
        {
          color: "primary",
          variant: "solid",
          class:
            "bg-primary-700 aria-disabled:bg-primary-700 " +
            "focus:shadow-[0px_0px_8px_0px_#34ACA880] " +
            "hover:bg-primary-800 " +
            "active:bg-primary-900 " +
            "disabled:opacity-25",
        },
        {
          color: "primary",
          variant: "outline",
          class:
            "ring ring-inset ring-neutral-200 bg-white text-neutral-700 aria-disabled:bg-white " +
            "focus:ring-primary-300 focus:shadow-[0px_0px_8px_0px_#34ACA880] " +
            "hover:ring-primary-400 hover:bg-primary-100 hover:text-primary-800 " +
            "active:ring-primary-500 active:bg-primary-200 active:text-primary-900 " +
            "disabled:opacity-25",
        },
        {
          color: "primary",
          variant: "ghost",
          class:
            "text-neutral-700 aria-disabled:bg-transparent" +
            "focus:ring-primary-300 focus:shadow-[0px_0px_8px_0px_#34ACA880] " +
            "hover:bg-neutral-50 hover:text-neutral-800 " +
            "active:bg-neutral-100 active:text-neutral-900" +
            "disabled:opacity-25 ",
        },

        {
          color: "info",
          variant: "link",
          class:
            "text-blue-500 aria-disabled:text-blue-500" +
            "hover:text-blue-600 " +
            "active:text-blue-700 " +
            "disabled:opacity-25 ",
        },

        {
          color: "error",
          variant: "outline",
          class:
            "ring ring-inset ring-red-300 bg-white text-red-500 aria-disabled:bg-white " +
            "focus:ring-red-300 focus:shadow-[0px_0px_8px_0px_#CA161680] " +
            "hover:ring-red-400 hover:bg-red-100 hover:text-red-600 " +
            "active:ring-red-500 active:bg-red-200 active:text-red-700 " +
            "disabled:opacity-25",
        },
        {
          color: "success",
          variant: "solid",
          class:
            "bg-green-500 aria-disabled:bg-green-500 " +
            "focus:shadow-[0px_0px_8px_0px_#34ACA880] " +
            "hover:bg-green-600 " +
            "active:bg-green-700 " +
            "disabled:opacity-25",
        },

        {
          variant: "link",
          class: "p-0",
        },
      ],
    },
    badge: {
      variants: {
        size: {
          sm: {
            base: "px-1 py-0 gap-2 text-xxs leading-xxs rounded-full h-[12px]",
            leadingIcon: "size-3",
            leadingAvatarSize: "3xs",
            trailingIcon: "size-3",
          },
          md: {
            base: "px-2 py-0.5 gap-2 text-xs leading-xs rounded-full h-[16px]",
            leadingIcon: "size-2",
            leadingAvatarSize: "3xs",
            trailingIcon: "size-2",
          },
          lg: {
            base: "px-3 py-1 gap-2 text-sm leading-sm rounded-full h-[20px]",
            leadingIcon: "size-5",
            leadingAvatarSize: "2xs",
            trailingIcon: "size-5",
          },
          // XL สำหรับ Tag
          xl: {
            base: "px-2 py-1.5 gap-1 text-sm leading-md rounded-md h-[24px]",
            leadingIcon: "size-4",
            trailingIcon: "size-4",
          },
        },
      },
      compoundVariants: [
        {
          color: "error",
          variant: "solid",
          class: {
            base: "text-white bg-red-500",
          },
        },
        {
          color: "warning",
          variant: "solid",
          class: {
            base: "text-white bg-amber-500",
          },
        },
        {
          color: "success",
          variant: "solid",
          class: {
            base: "text-white bg-green-500",
          },
        },
        {
          color: "info",
          variant: "solid",
          class: {
            base: "text-white bg-blue-500",
          },
        },
        {
          color: "secondary",
          variant: "subtle",
          class: {
            base: "bg-bg-secondary text-text-secondary",
          },
        },
        {
          color: "primary",
          variant: "soft",
          class: {
            base: "bg-bg-primary text-text-primary",
          },
        },
        {
          color: "secondary",
          variant: "soft",
          class: {
            base: "bg-bg-secondary text-text-secondary",
          },
        },
        {
          color: "success",
          variant: "soft",
          class: {
            base: "bg-bg-green text-text-green",
          },
        },
        {
          color: "orange",
          variant: "soft",
          class: {
            base: "bg-bg-orange text-text-orange",
          },
        },
        {
          color: "blue",
          variant: "soft",
          class: {
            base: "bg-bg-blue text-text-blue",
          },
        },
        {
          color: "warning",
          variant: "soft",
          class: {
            base: "bg-bg-amber text-text-amber",
          },
        },
        {
          color: "info",
          variant: "soft",
          class: {
            base: "bg-bg-cyan text-text-cyan",
          },
        },
        {
          color: "neutral",
          variant: "soft",
          class: {
            base: "bg-bg-neutral text-text-neutral",
          },
        },
      ],
      defaultVariants: {
        size: "xl",
      },
    },
    dropdownMenu: {
      slots: {
        item: "cursor-pointer",
      },
    },
    tabs: {
      slots: {
        list: "p-0",
        trigger: "cursor-pointer",
      },
      variants: {
        variant: {
          pill: {
            list: "bg-transparent rounded-lg",
          },
        },
      },
      compoundVariants: [
        {
          color: "neutral",
          variant: "pill",
          class: {
            indicator:
              "bg-white inset-y-0 shadow-none rounded-none rounded-t-lg",
            trigger: [
              "h-10 grow-0 rounded-none p-4 text-sm font-medium leading-sm",
              "data-[state=active]:rounded-t-lg data-[state=active]:bg-white data-[state=active]:text-text-neutral-lv1",
              "data-[state=active]:shadow-[0px_-2px_3px_0px_#5A698740]",
            ],
          },
        },
      ],
    },
    pagination: {
      slots: {
        item: "active:bg-neutral-100 hover:bg-neutral-50 ",
      },
    },
    formField: {
      variants: {
        size: {
          lg: {
            label: "text-base font-bold leading-sm text-text-neutral-lv1",
          },
        },
      },
      defaultVariants: {
        size: "lg",
      },
    },

    input: {
      slots: {
        base: "w-full placeholder:text-neutral-200 outline-neutral-200 disabled:text-neutral-opacity-50 [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none",
      },
      variants: {
        size: {
          sm: {
            base: "px-2 py-0.5 gap-2 text-xs font-medium leading-xs h-[24px]",
            leading: "ps-1",
            trailing: "pe-1",
            leadingIcon: "size-4",
            leadingAvatarSize: "3xs",
            trailingIcon: "size-4",
          },
          md: {
            base: "px-3 py-1.5 gap-2 text-sm font-medium leading-sm h-[32px]",
            leading: "ps-1.5",
            trailing: "pe-1.5",
            leadingIcon: "size-5",
            leadingAvatarSize: "2xs",
            trailingIcon: "size-5",
          },
          lg: {
            base: "px-4 py-2.5 gap-2 text-base font-medium leading-sm h-[40px]",
            leading: "ps-2.5",
            trailing: "pe-2.5",
            leadingIcon: "size-5",
            leadingAvatarSize: "2xs",
            trailingIcon: "size-5",
          },
          xl: {
            base: "px-4 py-2.5 gap-2 text-base font-medium leading-sm h-[48px]",
            leading: "ps-2.5",
            trailing: "pe-2.5",
            leadingIcon: "size-6",
            leadingAvatarSize: "xs",
            trailingIcon: "size-6",
          },
        },
      },
      compoundVariants: [
        {
          color: "primary",
          variant: ["outline", "subtle"],
          class:
            "hover:ring-primary-400 " +
            "focus-visible:outline-0 focus-visible:ring-primary-300 focus-visible:shadow-[0px_0px_8px_0px_#34ACA880] " +
            "active:outline-0 active:ring-primary-500 ",
        },
        {
          color: "error",
          variant: ["outline", "subtle"],
          class:
            "hover:ring-red-400 " +
            "focus-visible:outline-0 focus-visible:ring-red-300 focus-visible:shadow-[0px_0px_8px_0px_#CA161680] " +
            "active:outline-0 active:ring-red-500 ",
        },
        {
          leading: true,
          size: "sm",
          class: "ps-6",
        },
        {
          trailing: true,
          size: "sm",
          class: "pe-6",
        },
        {
          leading: true,
          size: "md",
          class: "ps-8",
        },
        {
          trailing: true,
          size: "md",
          class: "pe-8",
        },
        {
          leading: true,
          size: "lg",
          class: "ps-10",
        },
        {
          trailing: true,
          size: "lg",
          class: "pe-10",
        },
        {
          leading: true,
          size: "xl",
          class: "ps-10",
        },
        {
          trailing: true,
          size: "xl",
          class: "pe-10",
        },
      ],
    },
    selectMenu: {
      slots: {
        base: "w-full placeholder:text-neutral-200 outline-neutral-200 disabled:text-neutral-opacity-50 [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none",
      },
      variants: {
        size: {
          sm: {
            base: "px-2 py-0.5 gap-2 text-xs font-medium leading-xs h-[24px]",
            leading: "ps-1",
            trailing: "pe-1",
            leadingIcon: "size-4",
            leadingAvatarSize: "3xs",
            trailingIcon: "size-4",
          },
          md: {
            base: "px-3 py-1.5 gap-2 text-sm font-medium leading-sm h-[32px]",
            leading: "ps-1.5",
            trailing: "pe-1.5",
            leadingIcon: "size-5",
            leadingAvatarSize: "2xs",
            trailingIcon: "size-5",
          },
          lg: {
            base: "px-4 py-2.5 gap-2 text-base font-medium leading-sm h-[40px]",
            leading: "ps-2.5",
            trailing: "pe-2.5",
            leadingIcon: "size-5",
            leadingAvatarSize: "2xs",
            trailingIcon: "size-5",
          },
          xl: {
            base: "px-4 py-2.5 gap-2 text-base font-medium leading-sm h-[48px]",
            leading: "ps-2.5",
            trailing: "pe-2.5",
            leadingIcon: "size-6",
            leadingAvatarSize: "xs",
            trailingIcon: "size-6",
          },
        },
      },
      compoundVariants: [
        {
          color: "primary",
          variant: ["outline", "subtle"],
          class:
            "hover:bg-transparent hover:ring-primary-400 " +
            "data-[state=open]:outline-0 data-[state=open]:ring-primary-300 data-[state=open]:shadow-[0px_0px_8px_0px_#34ACA880] " +
            "active:outline-0 active:ring-primary-500 ",
        },
        {
          color: "error",
          variant: ["outline", "subtle"],
          class:
            "hover:bg-transparent hover:ring-red-500 " +
            "data-[state=open]:outline-0 data-[state=open]:ring-red-300 data-[state=open]:shadow-[0px_0px_8px_0px_#CA161680] " +
            "active:outline-0 active:ring-red-500 ",
        },
        {
          leading: true,
          size: "sm",
          class: "ps-6",
        },
        {
          trailing: true,
          size: "sm",
          class: "pe-6",
        },
        {
          leading: true,
          size: "md",
          class: "ps-8",
        },
        {
          trailing: true,
          size: "md",
          class: "pe-8",
        },
        {
          leading: true,
          size: "lg",
          class: "ps-10",
        },
        {
          trailing: true,
          size: "lg",
          class: "pe-10",
        },
        {
          leading: true,
          size: "xl",
          class: "ps-10",
        },
        {
          trailing: true,
          size: "xl",
          class: "pe-10",
        },
      ],
    },
    textarea: {
      slots: {
        base: "placeholder:text-neutral-200 outline-neutral-200 disabled:text-neutral-opacity-50",
      },
      variants: {
        size: {
          sm: {
            base: "px-2 py-1.5 gap-2 text-xs font-medium leading-xs",
            leading: "ps-2.5 inset-y-1.5",
            trailing: "pe-2.5 inset-y-1.5",
            leadingIcon: "size-4",
            leadingAvatarSize: "3xs",
            trailingIcon: "size-4",
          },
          md: {
            base: "px-3 py-1.5 gap-2 text-sm font-medium leading-sm",
            leading: "ps-2.5 inset-y-2.5",
            trailing: "pe-2.5 inset-y-2.5",
            leadingIcon: "size-5",
            leadingAvatarSize: "2xs",
            trailingIcon: "size-5",
          },
          lg: {
            base: "px-4 py-2.5 gap-2 text-base font-medium leading-sm",
            leading: "ps-3 inset-y-2",
            trailing: "pe-3 inset-y-2",
            leadingIcon: "size-5",
            leadingAvatarSize: "2xs",
            trailingIcon: "size-5",
          },
        },
      },
    },
    table: {
      slots: {
        root: "relative overflow-auto",
        tbody:
          "isolate [&>tr]:data-[selectable=true]:hover:bg-neutral-50 [&>tr]:data-[selectable=true]:outline-neutral-25 [&>tr]:data-[selectable=true]:focus-visible:outline-3 divide-y divide-default",
        tr: "data-[selected=true]:bg-neutral-50",
        th: "px-2 py-2 text-sm text-neutral-400 text-left rtl:text-right font-bold [&:has([role=checkbox])]:pe-0",
        td: "py-3 px-2 text-base text-neutral-800 whitespace-nowrap [&:has([role=checkbox])]:pe-0 align-top",
        empty: "py-6 text-center text-sm text-neutral-400",
      },
      variants: {
        externalScroll: {
          true: {
            root: "overflow-visible",
          },
        },
      },
    },
    inputNumber: {
      slots: {
        base: [
          "w-full rounded-md border-0 placeholder:text-dimmed disabled:cursor-not-allowed disabled:opacity-75 focus:outline-none min-w-10",
        ],
      },
      variants: {
        size: {
          md: "px-3 py-1.5 text-sm font-medium leading-sm gap-2",
        },
        variant: {
          outline: "text-highlighted bg-white ring ring-inset ring-neutral-200",
        },
      },
      compoundVariants: [
        {
          color: "neutral",
          variant: ["outline", "subtle"],
          class: "outline-neutral-200/50 focus-visible:outline-3",
        },
        {
          color: "neutral",
          highlight: true,
          class: "ring ring-inset ring-neutral-300",
        },
      ],
    },
    fileUpload: {
      slots: {
        root: "w-full gap-3",
        base: "min-h-36 px-4 py-5",
        wrapper: "gap-0",
        avatar: "size-14 rounded-2xl bg-transparent shadow-none",
        label: "mt-4 text-sm font-semibold",
        description: "text-xs",
        files: "w-full gap-3",
      },
      variants: {
        dropzone: {
          true: "data-[dragging=true]:bg-primary-100 data-[dragging=true]:border-primary-300",
        },
      },
      compoundVariants: [
        {
          interactive: true,
          disabled: false,
          class: "hover:border-primary hover:bg-white",
        },
      ],
    },
    progress: {
      variants: {
        color: {
          primary: {
            base: "bg-primary-100",
            indicator: "bg-primary-500",
          },
          error: {
            base: "bg-error-100",
          },
        },
      },
    },
    card: {
      slots: {
        root: `w-full rounded-xl border-0 shadow-[1px_1px_8px_0px_#5A698740]`,
        body: "p-4 sm:p-4",
      },
    },
    modal: {
      slots: {
        header: "p-0 sm:p-0 border-b-0",
        body: "p-0 sm:p-0",
        footer: "p-0 sm:p-0",
        content: "z-[9000] p-6 gap-6",
        overlay: "z-[9000]",
      },
    },
    radioGroup: {
      slots: {
        item: "gap-2 border-b border-neutral-100 py-4 px-0",
        wrapper: "ms-0",
        label: "text-base leading-sm text-neutral-800",
      },
      defaultVariants: {
        size: "md",
      },
    },
    stepper: {
      slots: {
        header: "gap-2",
        item: [
          "flex flex-wrap items-center justify-center gap-2",
          "after:h-1 after:w-full after:rounded-full after:bg-secondary-200",
          "data-[state=completed]:after:bg-primary-500/50 data-[state=active]:after:bg-primary-500 ",
        ],
        trigger: [
          "text-sm leading-sm font-bold text-white ",
          "bg-secondary-200 ",
          "group-data-[state=completed]:bg-primary-500/50 group-data-[state=active]:bg-primary-500",
        ],
      },
      variants: {
        size: {
          md: {
            trigger: "size-6 text-sm font-bold leading-sm",
            icon: "size-6",
            title: "text-base font-bold leading-sm",
            description: "text-sm",
            wrapper: "mt-0!",
          },
        },
        color: {
          primary: {
            title: [
              "text-text-neutral-lv2 ",
              "group-data-[state=completed]:text-primary/50 group-data-[state=active]:text-primary",
            ],
            trigger: [
              "text-text-neutral-lv2 ",
              "group-data-[state=completed]:opacity-50 group-data-[state=active]:bg-primary-500",
            ],
            separator: "hidden",
          },
        },
      },
    },
    drawer: {
      slots: {
        content: "ring-0 shadow-[1px_2px_8px_0px_#5A698740]",
      },
    },
    collapsible: {
      slots: {
        content: "rounded-b-lg border border-t-0 border-neutral-100 px-4 py-3",
      },
    },
    timeline: {
      slots: {
        root: "gap-0",
        item: "min-h-12",
        container: "gap-0",
        wrapper: "mt-0 sm:mt-0 pb-1 sm:pb-1",
        indicator: "size-3",
      },
      variants: {
        orientation: {
          vertical: {
            separator: "w-[1px]",
          },
        },
        color: {
          primary: {
            indicator:
              "group-data-[state=active]:border group-data-[state=active]:border-primary-200 group-data-[state=active]:bg-primary-100 group-data-[state=completed]:bg-primary-500",
          },
        },
      },
      compoundVariants: [
        {
          color: "primary",
          reverse: false,
          class: {
            separator: "group-data-[state=completed]:bg-primary-500",
          },
        },
        {
          color: "primary",
          reverse: true,
          class: {
            separator:
              "group-data-[state=active]:bg-primary-500 group-data-[state=completed]:bg-primary-500",
          },
        },
      ],
    },
  },
});
